import {
  FETCH_LATEST_NEWS_REQUEST,
  FETCH_LATEST_NEWS_SUCCESS,
  FETCH_LATEST_NEWS_FAILURE,
} from "../actions/latestnewsActions";

const initialState = {
  loading: false,
  news: [],
  error: null,
};

export const latestNewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LATEST_NEWS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_LATEST_NEWS_SUCCESS:
      return { ...state, loading: false, news: action.payload };
    case FETCH_LATEST_NEWS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
